import React from 'react'
import { change as changeFieldValue, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import { showErrorMsg, showSuccessMsg } from '../../util/messagesUtil';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import cancelarReservasComReembolso from '../../actions/reserva/cancelarReservasComReembolso';
import selecionaReservaReembolsoSolicitado from '../../actions/reserva/selecionaReservaReembolsoSolicitado';
import anexarDocumentoReservaReembolsoSolicitado from '../../actions/reserva/anexarDocumentoReservaReembolsoSolicitado';

export class ModalAnexaDocumentoReservasParaReembolsoEfetivado extends React.Component {
  fecharModal () {
    $('#modalAnexaDocumentoReservasParaReembolsoEfetivado').modal('hide');
    $('#modalAnexaDocumentoReservasParaReembolsoEfetivado').hide();
    $('.modal-backdrop').hide();
    this.props.selecionaReservaReembolsoSolicitado();
    this.removerArquivo();
  }

  montarParametros() {
    return {
      empresaId: this.props.empresaSelecionada.id,
      reservaId: this.props.reservaSelecionada.id,
      base64ComprovanteReembolso: this.props.base64ComprovanteReembolso,
      nomeComprovanteReembolso: this.props.nomeComprovanteReembolso
    }
  }

  submit () {
    if (!this.props.base64ComprovanteReembolso || !this.props.nomeComprovanteReembolso) {
      showErrorMsg('Falta anexar o comprovante');
      return;
    }

    this.props.anexarDocumentoReservaReembolsoSolicitado(this.montarParametros())
      .then(() => {
          showSuccessMsg('Documento Anexado Com Sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  handleChange(event) {
      const file = event.target.files[0];
      if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
          return
      }
      if (file.size > tamanhoArquivoUpload) {
          showErrorMsg('Tamanho do arquivo excede 20 MB');
          return
      }
      this.converterParaBase64(file)
  }

  removerArquivo() {
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado', 'base64ComprovanteReembolso', null);
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado', 'nomeComprovanteReembolso', null);
      this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado', 'urlComprovanteTransferencia', null);
  }

  converterParaBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
          this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado', 'base64ComprovanteReembolso', reader.result);
          this.props.changeFieldValue('formularioAnexarDocumentoReservasParaReembolsoEfetivado', 'nomeComprovanteReembolso', file.name);
      }.bind(this);
  }

  exibirAnexar() {
    if (this.props.base64ComprovanteReembolso || this.props.urlComprovanteTransferencia) {
      return (
        <div className="vx-modal-attach">
          <div className="vx-modal-attach-file">
            <span className="material-icons">attach_file</span>
            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{this.props.nomeComprovanteReembolso}</span>
            <button type="button" className="vx-modal-attach-remove" onClick={() => this.removerArquivo()}>
              <span className="material-icons">delete</span>
              Remover
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="vx-modal-attach">
        <div className="input-wrapper">
          <label className="vx-modal-attach-btn" htmlFor="input-file-anexo-reembolso">
            <span className="material-icons">file_upload</span>
            Anexar comprovante
          </label>
          <input id='input-file-anexo-reembolso' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChange.bind(this)} style={{display: 'none'}}/>
        </div>
        <p className="vx-modal-attach-hint">
          * Tamanho máximo permitido: 20 MB<br/>
          * Formatos suportados: PNG, JPEG, PDF<br/>
          * Para unir imagens: <a target="_BLANK" href='https://smallpdf.com/pt/jpg-para-pdf' rel='noreferrer'>smallpdf.com/pt/jpg-para-pdf</a><br/>
          * Para unir PDFs: <a target="_BLANK" href='https://smallpdf.com/pt/juntar-pdf' rel='noreferrer'>smallpdf.com/pt/juntar-pdf</a>
        </p>
      </div>
    );
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalAnexaDocumentoReservasParaReembolsoEfetivado" tabIndex="-1" role="dialog"
           aria-labelledby="modalAnexaDocumentoReservasParaReembolsoEfetivado" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">file_upload</span>
                Anexar Documento de Reembolso
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body">
                <div className="vx-modal-bilhete">
                  <span className="material-icons">confirmation_number</span>
                  Bilhete: {this.props.reservaSelecionada.id}
                </div>
                {this.exibirAnexar()}
              </div>
              <div className="vx-modal-footer">
                <button id='cancelar' type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                  Não
                </button>
                <button type="button" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar vx-modal-btn-reembolso-confirmar"
                        onClick={() => this.submit()}>
                  <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
                  Sim, anexar
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

const selector = formValueSelector('formularioAnexarDocumentoReservasParaReembolsoEfetivado');

export const mapStateToProps = state => (
  {
    initialValues: {
      base64ComprovanteReembolso: state.reservaSelecionadaReembolsoSocilitado.comprovanteReembolso,
      nomeComprovanteReembolso: state.reservaSelecionadaReembolsoSocilitado.nomeComprovanteReembolso,
    },
    reservaSelecionada: state.reservaSelecionadaReembolsoSocilitado,
    empresaSelecionada: state.empresaSelecionada,
    urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
    nomeComprovanteReembolso: selector(state, 'nomeComprovanteReembolso'),
    base64ComprovanteReembolso: selector(state, 'base64ComprovanteReembolso'),
  });

export default connect(mapStateToProps, {
  cancelarReservasComReembolso,
  selecionaReservaReembolsoSolicitado,
  anexarDocumentoReservaReembolsoSolicitado,
  changeFieldValue
})(reduxForm({
  form: 'formularioAnexarDocumentoReservasParaReembolsoEfetivado',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalAnexaDocumentoReservasParaReembolsoEfetivado));
